import { Link } from 'react-router-dom';
import { getImageUrl } from '../utils/imageUrl';

const stripHtmlTags = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const NewsCard = ({ news }) => {
  const getCategoryColor = (category) => {
    const lowerCategory = category.toLowerCase();
    if (lowerCategory.includes('pengabdian')) return 'bg-green-50 text-green-700';
    if (lowerCategory.includes('pengembangan')) return 'bg-blue-50 text-blue-700';
    if (lowerCategory.includes('penelitian')) return 'bg-purple-50 text-purple-700';
    return 'bg-gray-100 text-gray-700';
  };

  const imageUrl = getImageUrl(news.image);

  return (
    <article className="group bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
      <Link to={`/news/read/${news._id}`} className="block">
        {imageUrl && (
          <div className="relative aspect-video overflow-hidden bg-gray-100">
            <img
              src={imageUrl}
              alt={news.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
        )}
        <div className="p-5">
          <div className="flex items-center gap-2 mb-3">
            <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${getCategoryColor(news.category)}`}>
              {news.category}
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-dark-blue-700 transition-colors">{news.title}</h3>
          <p className="text-gray-600 text-sm mb-3 line-clamp-3">{stripHtmlTags(news.content)}</p>
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>Oleh: {news.author}</span>
            {news.createdAt && (
              <span>{new Date(news.createdAt).toLocaleDateString('id-ID')}</span>
            )}
          </div>
        </div>
      </Link>
    </article>
  );
};

export default NewsCard;
